export { default } from "./TranslateDrawerFooter";
